<template>
  <footer>
    <div v-if="!noNewsletter"
        class="h-pad py-10 md:py-17.5 bg-gradient-to-b from-transparent to-deep-indigo-soft md:flex md:flex-col md:items-center md:text-center">
      <div class="flex flex-col gap-1.5 mb-5">
        <Icon id="logo" class="text-[22px] ml-4 text-lilac-pale"/>
        <Icon id="star" class="text-[10px] text-lilac-base"/>
      </div>
      <h2 class="text-3xl md:text-5xl mb-5">{{ $t('newsletter.title') }}</h2>
      <p class="description text-base md:text-lg mb-6">{{ $t('newsletter.description') }}</p>
      <Transition name="fade" mode="out-in">
        <form v-if="!form.submitted && !form.saved" action=""
              class="md:w-full md:max-w-[800px] flex flex-col md:flex-row md:items-end gap-5"
              @submit.prevent="submit">
          <FormInput :label="$t('labels.email')" name="email" :placeholder="$t('labels.email')"
                     v-model="form.fields.email" no-label class="grow"/>
          <button class="button ml-auto" :disabled="!valid || form.submitted">{{ $t('newsletter.submit') }}</button>
        </form>
        <div v-else-if="form.submitted && !form.saved" class="h-12">
          <div class="loader"/>
        </div>
        <div v-else class="h-12 flex items-center">
          <p>{{ $t('newsletter.confirmation') }}</p>
        </div>
      </Transition>
    </div>
    <div :class="['text-sm leading-5 text-center p-5 text-lilac-grey h-pad bg-deep-indigo-black flex flex-col gap-5 md:flex-row justify-between', {'md:pb-40': $route.name.includes($routes.ORGANIZATION.SHOW)}]">
      <p>{{ $t('trademark') }}</p>
      <LangRouterLink :to="{name: $routes.PRIVACY}">{{ $t('labels.privacy_policy') }}</LangRouterLink>
    </div>
  </footer>
</template>

<script>
import {Icon, LangRouterLink} from '@/components/helpers'
import {FormInput} from '@/components/form/inputs'
import {FormValidMixin} from '@/components/form/mixins'
import {useNewsletterStore} from '@/stores/newsletter.js'

export default {
  name: 'SiteFooter',
  mixins: [FormValidMixin],
  components: {FormInput, Icon, LangRouterLink},
  props: {
    noNewsletter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        fields: {
          email: {
            valid: false,
            value: null
          }
        },
        saved: false,
        submitted: false
      }
    }
  },
  methods: {
    async submit() {
      if (this.valid) {
        this.form.submitted = true

        const valid = await useNewsletterStore().subscribe(this.form.fields.email.value)
        if (valid) {
          this.form.saved = true
          setTimeout(() => {
            this.form.saved = false
          }, 2000)
        } else {
          this.$notice.report('newsletter.error')
        }

        this.form.submitted = false
      }
    }
  }
}
</script>